import React from "react";
import { Grid, Container } from "@mui/material";
import cssExports from "theme/styles/main.module.scss";
import Logo from "images/logo-small.png";
import { Link } from "react-router-dom";
import clsx from "clsx";
import { Icon, StyledButton } from "components/common";
import { IconDefinitionConstants } from "utils/constants";
import { LocalizationHelperInstance } from "utils/helpers";
import { TranslationKeys } from "translations";

export interface CompanyLink {
  id: number;
  name: string;
  url: string;
}

export interface CompanySelectionProps {
  title: React.ReactNode;
  explanation: React.ReactNode;
  selectCompanyText?: React.ReactNode;
  companies: CompanyLink[];
  logOut: () => void;
}

const CompanySelection: React.FC<CompanySelectionProps> = (props) => {
  const onLogoutClick = () => {
    props.logOut();
  };

  return (
    <div className={cssExports.errorViewBackground}>
      <Container maxWidth="sm" className={clsx(cssExports.errorViewContainer, cssExports.companyNotFoundContainer)}>
        <Grid container className={cssExports.errorViewContent} direction="column">
          <Grid item container className={cssExports.header}>
            <Grid item container spacing={0} className={cssExports.logoImg}>
              <img src={Logo} />
            </Grid>
            <Grid item container spacing={0} className={cssExports.title}>
              {props.title}
            </Grid>
            <Grid item container spacing={0} className={cssExports.descriptionText}>
              {props.explanation}
            </Grid>
          </Grid>
          {props.companies.length ? (
            <>
              {props.selectCompanyText ? (
                <Grid item container spacing={0} className={cssExports.companyListTitle}>
                  {props.selectCompanyText}
                </Grid>
              ) : (
                <></>
              )}
              <ul className={cssExports.companyList}>
                {props.companies.map((company) => (
                  <li key={company.id}>
                    <Icon icon={IconDefinitionConstants.WArrowSmallRight} />
                    <Link to={company.url}>{company.name}</Link>
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <></>
          )}
          <Grid item container spacing={0} className={cssExports.link}>
            <StyledButton onClick={onLogoutClick}>
              {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Logout)}
            </StyledButton>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default CompanySelection;
